import { render, staticRenderFns } from "./OptionShowSelectedIfTab.vue?vue&type=template&id=2afcf739"
import script from "./OptionShowSelectedIfTab.vue?vue&type=script&lang=ts"
export * from "./OptionShowSelectedIfTab.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports